import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import RegulationsStageTagsDt from '@/services/dataTransferModules/regulationsStageTagsDt'

export default function useRegulationsStageTags(params = {}) {
	const regulationsStageTagsDt = new RegulationsStageTagsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingRegulationsStageTags: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: regulationsStageTags,
		getEntities: getRegulationsStageTags,

		createEntity: createRegulationsStageTag,

		entity: regulationsStageTag,
		getEntity: getRegulationsStageTag,

		patchEntity: updateRegulationsStageTag,
		updateEntity: fullUpdateRegulationsStageTag,

		entityPreview: regulationsStageTagPreview,
		getEntityPreview: getRegulationsStageTagPreview,

		deleteEntity: deleteRegulationsStageTag,
	} = useBlProviders(
		regulationsStageTagsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Stage tag loading error'),

				showErrorNotificationForCreatingEntity: true,

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		regulationsStageTagPreview,
		regulationsStageTags,
		regulationsStageTag,
		defaults,
		getRegulationsStageTagPreview,
		getRegulationsStageTags,
		getRegulationsStageTag,
		createRegulationsStageTag,
		deleteRegulationsStageTag,
		updateRegulationsStageTag,
		fullUpdateRegulationsStageTag,
	}
}
